import { HostMode, type SchedulingEventType } from '../../../models/Scheduling'
import { FallbackModes, MeetingOwnerModes, type FallbackMode, type MeetingOwnerMode } from './meetingOwnerMode'

export const isOwnerBookable = (eventType: SchedulingEventType): boolean => eventType.hostMode !== HostMode.ROTATING

export const firstSelectableEventType = (eventTypes: SchedulingEventType[]): SchedulingEventType | undefined =>
  eventTypes.find((eventType) => eventType.active && isOwnerBookable(eventType))

export interface HostSelection {
  mode: MeetingOwnerMode
  ownerUserId: string
  fallback: FallbackMode
  backupOwnerId: string
  sharedUserIds: Set<string>
}

export const hostIdForClient = (ownerId: string | null, hostSelection: HostSelection): string | null => {
  if (hostSelection.mode === MeetingOwnerModes.SINGLE) {
    return hostSelection.ownerUserId
  }
  if (ownerId !== null && hostSelection.sharedUserIds.has(ownerId)) {
    return ownerId
  }
  return hostSelection.fallback === FallbackModes.SEND ? hostSelection.backupOwnerId : null
}

export interface HostWithoutEventType {
  userId: string
  clientIds: string[]
  clientCount: number
}

export const hostsWithoutEventType = (
  ownerIdByClientId: Record<string, string | null>,
  hostSelection: HostSelection,
  enabledUserIds: Set<string>,
): HostWithoutEventType[] => {
  const clientIdsByHost = Object.entries(ownerIdByClientId).reduce<Record<string, string[]>>((byHost, [clientId, ownerId]) => {
    const hostId = hostIdForClient(ownerId, hostSelection)
    if (hostId !== null && !enabledUserIds.has(hostId)) {
      byHost[hostId] = byHost[hostId] ?? []
      byHost[hostId].push(clientId)
    }
    return byHost
  }, {})
  return Object.entries(clientIdsByHost)
    .map(([userId, clientIds]) => ({ userId, clientIds, clientCount: clientIds.length }))
    .sort((a, b) => b.clientCount - a.clientCount)
}
